import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/providers/ApiProvider'
import type { ApiResponse } from '@/services/api'

// ─────────────────────────────────────────────
// Types
// ─────────────────────────────────────────────
export interface UserProfile {
  id: number
  name: string
  role: string
  discord_id: string
  totemAnimal: string
}

// ─────────────────────────────────────────────
// Query keys
// ─────────────────────────────────────────────
export const AUTH_QUERY_KEYS = {
  me: ['auth', 'me'] as const,
}

export const useCurrentUser = () => {
  const { api } = useApi()

  return useQuery<UserProfile>({
    queryKey: AUTH_QUERY_KEYS.me,
    queryFn: async () => {
      const response = await api.get<ApiResponse<UserProfile>>('/auth/me')
      return response.data
    },
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  })
}

/** Appelle le backend pour effacer le cookie JWT (HttpOnly). */
export const removeToken = (): void => {
  void fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
}
